import { Observable } from "rxjs"
import { s, Shape } from "../shapes"
import { Channel } from "./channel"

export namespace RTC {
  export type Client = {
    /**
     * Create a new Peer endpoint
     * @param signalingChannel 
     */
    createPeer(signalingChannel: SignalChannelPort): Peer,

    /**
     * Create a new Peer endpoint, based off a "offer"
     * signal request
     * @param signalingChannel 
     * @param message 
     */
    createPeerFromOffer(
      signalingChannel: SignalChannelPort,
      message: Extract<SignalMessage, { type: 'offer' }>,
    ): Promise<Peer>
  }

  /**
   * Minimum info needed to construct an ICECandidate
   */
  export type CandidateInfo = {
    candidate: string,
    sdpMid: string | null,
    sdpMLineIndex: number | null,
    usernameFragment: string | null,
  }

  export type SignalMessage =
    | { type: 'offer', sdp: string }
    | { type: 'answer', sdp: string }
    | { type: 'candidate', info: CandidateInfo }

  export type SignalChannelPort = Channel.Port<SignalMessage, SignalMessage>;

  export type Peer = {
    sendMedia(track: MediaStreamTrack): void,

    onMedia: Observable<MediaStreamTrack>,
  }
};

const CandidateInfo = s.ref<RTC.CandidateInfo>()(s.o({
  candidate: s.str,
  sdpMid: s.optional(s.str),
  sdpMLineIndex: s.optional(s.num),
  usernameFragment: s.optional(s.str),
}))

const SignalMessage = s.ref<RTC.SignalMessage>()(s.du('type', {
  'offer': { sdp: s.str },
  'answer': { sdp: s.str },
  'candidate': { info: CandidateInfo },
}))

export const RTC = {
  CandidateInfo,
  SignalMessage,
}
